// ── 매입 표 🎨 줄 색 (2026-11-03 사용자 "칸 선택누르면 상단에 페인트 아이콘") ───────────
// 줄을 체크했거나 칸을 눌러 줄을 고치는 중이면 표 위에 🎨 가 뜬다 → 색 4가지·지우기 → 그 줄 전체를 칠한다(결정 4-b).
// 버튼은 mousedown 기본 동작을 막는다 — 고치는 줄의 칸에서 커서가 빠지면 그 줄이 저장되고 닫혀 버려서.
import React, { useState } from 'react';
import { ROW_COLORS } from './purchaseRowForm';

const keepFocus = (e) => e.preventDefault();

export default function RowColorBar({ targetCount, onPick }) {
  const [open, setOpen] = useState(false);
  if (!targetCount) return null;
  const pick = (key) => { setOpen(false); onPick(key); };
  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <button type="button" title="줄 색 칠하기" onMouseDown={keepFocus} onClick={() => setOpen((o) => !o)} style={paintBtn(open)}>
        🎨 <span style={{ fontSize: 12 }}>색</span>
      </button>
      {open && (
        <div style={palette}>
          {ROW_COLORS.map((c) => (
            <button key={c.key} type="button" title={c.label} aria-label={`${c.label}으로 칠하기`}
              onMouseDown={keepFocus} onClick={() => pick(c.key)} style={swatch(c.swatch)} />
          ))}
          <button type="button" onMouseDown={keepFocus} onClick={() => pick(null)} style={clearBtn}>색 지우기</button>
        </div>
      )}
    </div>
  );
}

const paintBtn = (open) => ({
  display: 'inline-flex', alignItems: 'center', gap: 4, padding: '6px 10px', borderRadius: 10, cursor: 'pointer',
  border: `1px solid ${open ? 'var(--accent, #2563eb)' : 'var(--border)'}`, background: 'var(--bg-card)', color: 'var(--text)',
  fontSize: 15, fontWeight: 700,
});
const palette = {
  position: 'absolute', top: 'calc(100% + 6px)', left: 0, zIndex: 30, display: 'flex', alignItems: 'center', gap: 8,
  padding: '8px 10px', borderRadius: 12, border: '1px solid var(--border)', background: 'var(--bg-card)',
  boxShadow: '0 6px 20px rgba(0,0,0,0.15)', whiteSpace: 'nowrap',
};
const swatch = (color) => ({
  width: 26, height: 26, borderRadius: 8, cursor: 'pointer', border: '2px solid var(--bg-card)',
  outline: '1px solid var(--border)', background: color, padding: 0,
});
const clearBtn = {
  padding: '5px 10px', borderRadius: 8, cursor: 'pointer', border: '1px solid var(--border)',
  background: 'var(--bg-card)', color: 'var(--text-sub)', fontSize: 12, fontWeight: 600,
};
